import {CurrencyType} from "./CurrencyType";

export const CurrencyTypeNames: Record<CurrencyType, string> = {
  [CurrencyType.USR]: "Dólares Estadounidenses",
  [CurrencyType.ARS]: "Pesos Argentinos",
};
